import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Link,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { db, auth, storage } from "../Config/firebase";
import {
  addDoc,
  collection,
  Timestamp,
  getDocs,
  getCountFromServer,
  query,
  orderBy,
  doc,
  updateDoc,
  where,
  limit,
  startAfter,
} from "firebase/firestore";

import { ref, getDownloadURL } from "firebase/storage";
import Autocomplete from "@mui/material/Autocomplete";
/* ✅ NAVBAR ALTERADO */
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import PaginationComponent from "../Components/PaginationComponents/paginationcomponents";
import PaginationSelector from "../Components/PaginationSelector/paginationselector";
import TutorialCadastro from "../Components/TutorialCadastro/TutorialCadastro";
import { ETAPAS_TUTORIAL_OBRAS } from "../Components/TutorialCadastro/etapasTutoriais";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useHistory } from "react-router-dom";
import { aplicarTenant, getUsuarioAtualComTenant, tenantWhere , consultaTenantAtual, aplicarTenantAtual} from "../Utils/tenant";
import { podeEditarCadastroDireto } from "../Utils/aprovacaoCadastro";
import {
  atualizarDocumentoComMesclagem,
  extrairCamposAlterados,
} from "../Utils/concorrenciaFirestore";

import "./CadastroObras.css";

const ITENS_POR_PAGINA_OBRAS = 20;

function dataCadastroISO(valor) {
  if (!valor) return "";
  if (typeof valor === "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor)) return valor;
  const data = valor.toDate ? valor.toDate() : new Date(valor);
  if (Number.isNaN(data.getTime())) return "";
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
}

export default function CadastroObras({ open, isMobile }) {
  /* =========================
     STATES
  ========================= */
  const [nome, setNome] = useState("");
  const [dataCadastro, setDataCadastro] = useState("");
  const [nomeEtiqueta, setNomeEtiqueta] = useState("");
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [obras, setObras] = useState([]);
  const [totalObras, setTotalObras] = useState(null);
  const [obrasBusca, setObrasBusca] = useState(null);
  const [carregandoLista, setCarregandoLista] = useState(true);
  const [userName, setUserName] = useState("");
  const [obraEditando, setObraEditando] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openTutorial, setOpenTutorial] = useState(false);
  const [mostrarDetalhes, setMostrarDetalhes] = useState(false);
  const [calibracoesPrensa, setCalibracoesPrensa] = useState([]);
  const [prensaVinculada, setPrensaVinculada] = useState(null);
  const [mostrarTodosCertificados, setMostrarTodosCertificados] = useState(false);
  const [rupturaExternaPadrao, setRupturaExternaPadrao] = useState(false);
  const [responsavelProducaoConcreto, setResponsavelProducaoConcreto] = useState("");
  const [concreteiras, setConcreteiras] = useState([]);

  const [clienteEtiquetaManual, setClienteEtiquetaManual] = useState("");
  const [endereco, setEndereco] = useState("");

  const [pesquisa, setPesquisa] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("ativas");
  const [currentPage, setCurrentPage] = useState(0);
  const [itensPerPage, setItensPerPage] = useState(ITENS_POR_PAGINA_OBRAS);
  const [lastDocs, setLastDocs] = useState([]);
  const [pages, setPages] = useState(1);
  const [usuarioAtual, setUsuarioAtual] = useState(null);
  const [openCadastroConcluido, setOpenCadastroConcluido] = useState(false);
  const history = useHistory();



  /* =========================
     USUÁRIO LOGADO
  ========================= */
  useEffect(() => {
    async function carregarUsuario() {
      if (!auth.currentUser) return;
      const usuario = await getUsuarioAtualComTenant();
      setUsuarioAtual(usuario);
      setUserName(usuario.nome);
    }

    carregarUsuario();
  }, []);

  /* =========================
     BUSCAR ÚLTIMO LAUDO
  ========================= */
  async function buscarLaudosDaObra(obraId) {
    try {
      const q = query(
        collection(db, "laudos"),
        ...tenantWhere(usuarioAtual),
        where("obraId", "==", obraId),
        orderBy("criadoEm", "desc"),
        limit(1)
      );

      const snapshot = await getDocs(consultaTenantAtual(q));

      return snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
    } catch (err) {
      console.error("Erro ao buscar laudos:", err);
      return [];
    }
  }

      /* =========================
     Novo cliente
  ========================= */

  async function carregarClientes() {
  const q = query(
    collection(db, "clientes"),
    ...tenantWhere(usuarioAtual),
    where("ativo", "==", true),
    orderBy("nome")
  );
  const snapshot = await getDocs(consultaTenantAtual(q));

  const lista = snapshot.docs.map(d => ({
    id: d.id,
    ...d.data()
  }));

  setClientes(lista);
}

useEffect(() => {
  if (usuarioAtual) carregarClientes();
}, [usuarioAtual]);

async function carregarConcreteiras() {
  const snapshot = await getDocs(
    consultaTenantAtual(query(collection(db, "concreteiras"), orderBy("nome")))
  );

  setConcreteiras(
    snapshot.docs
      .map((documento) => ({ id: documento.id, ...documento.data() }))
      .filter((concreteira) => concreteira.ativo !== false)
  );
}

useEffect(() => {
  if (usuarioAtual) carregarConcreteiras();
}, [usuarioAtual]);

function obterNumeroCertificado(prensa) {
  return (
    prensa?.certificadoPadrao ||
    prensa?.certificado ||
    prensa?.numeroCertificado ||
    prensa?.codigo ||
    ""
  );
}

function formatarOpcaoPrensa(prensa) {
  const certificado = obterNumeroCertificado(prensa);
  const codigo =
    prensa?.codigo && prensa.codigo !== certificado ? prensa.codigo : "";
  const descricao = [
    prensa?.empresa || prensa?.cliente || "Cliente não informado",
    certificado && `Certificado ${certificado}`,
    codigo,
    prensa?.equipamento,
    prensa?.serie && `Série ${prensa.serie}`
  ].filter(Boolean);

  return descricao.join(" - ");
}

function normalizarNome(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function resumirPrensa(prensa) {
  if (!prensa?.id) return null;

  return {
    id: prensa.id,
    codigo: prensa.codigo || "",
    certificadoPadrao: prensa.certificadoPadrao || "",
    certificado: prensa.certificado || "",
    numeroCertificado: prensa.numeroCertificado || "",
    equipamento: prensa.equipamento || "",
    serie: prensa.serie || "",
    empresa: prensa.empresa || "",
    obra: prensa.obra || "",
    usoInterno:
      prensa.usoInterno === true ||
      String(prensa.usoInterno || "").toLowerCase() === "true",
    dataCalibracao: prensa.dataCalibracao || prensa.data || "",
    dataVencimento: prensa.dataVencimento || ""
  };
}

const calibracoesDoCliente = useMemo(() => {
  const nomeCliente = normalizarNome(clienteSelecionado?.nome);
  if (!nomeCliente) return [];

  return calibracoesPrensa.filter(
    (prensa) =>
      normalizarNome(prensa.empresa || prensa.cliente) === nomeCliente
  );
}, [calibracoesPrensa, clienteSelecionado]);

const calibracoesDisponiveis = mostrarTodosCertificados
  ? calibracoesPrensa
  : calibracoesDoCliente;

async function carregarCalibracoesPrensa() {
  try {
    const snapshot = await getDocs(
      query(collection(db, "tblCalibracaoPrensas"), ...tenantWhere(usuarioAtual))
    );

    const lista = snapshot.docs
      .map((item) => ({ id: item.id, ...item.data() }))
      .filter((prensa) => String(obterNumeroCertificado(prensa)).trim() !== "")
      .sort((a, b) =>
        String(b.dataCalibracao || b.data || "").localeCompare(
          String(a.dataCalibracao || a.data || "")
        )
      );

    setCalibracoesPrensa(lista);
  } catch (err) {
    console.error("Erro ao carregar prensas:", err);
    setCalibracoesPrensa([]);
  }
}

useEffect(() => {
  if (usuarioAtual) carregarCalibracoesPrensa();
}, [usuarioAtual]);
  
    /* =========================
     NOVA OBRA
  ========================= */
    function novaObra() {
      setObraEditando(null);
      setDataCadastro(dataCadastroISO(new Date()));
      setNome("");
      setNomeEtiqueta("");
      setClienteSelecionado(null);
      setPrensaVinculada(null);
      setMostrarTodosCertificados(false);
      setRupturaExternaPadrao(false);
      setResponsavelProducaoConcreto("");
      setOpenDialog(true);
    }

    useEffect(() => {
      if (new URLSearchParams(window.location.search).get("novo") === "1") {
        novaObra();
      }
    }, []);

  /* =========================
     EDITAR OBRA
  ========================= */
      function editarObra(obra) {
        setObraEditando(obra);
        setDataCadastro(dataCadastroISO(obra.dataCadastro || obra.criadoEm));
        setNome(obra.nome || "");
        setEndereco(obra.endereco || "");
        setNomeEtiqueta(obra.nomeEtiqueta || "");      
        setClienteEtiquetaManual(obra.clienteEtiqueta || "");
        setClienteSelecionado({
          id: obra.clienteId,
          nome: obra.clienteNome,
        });
        setPrensaVinculada(obra.prensaRupturaPadrao || null);
        setMostrarTodosCertificados(false);
        setRupturaExternaPadrao(obra.rupturaExternaPadrao === true);
        setResponsavelProducaoConcreto(obra.responsavelProducaoConcreto || "");

        setOpenDialog(true);
      }

  /* =========================
     CARREGAR OBRAS
  ========================= */
  async function carregarObras(page = currentPage) {
    setCarregandoLista(true);
    setTotalObras(null);

    try {
      const constraints = [];
      constraints.push(...tenantWhere(usuarioAtual));

      if (filtroStatus === "ativas") constraints.push(where("ativo", "==", true));
      if (filtroStatus === "inativas") constraints.push(where("ativo", "==", false));

      constraints.push(orderBy("nome", "asc"));

      const consultaContagem = consultaTenantAtual(query(collection(db, "obras"), ...constraints));

      if (page > 0 && lastDocs[page - 1]) {
        constraints.push(startAfter(lastDocs[page - 1]));
      }

      constraints.push(limit(itensPerPage + 1));

      const [snapshot, contagem] = await Promise.all([
        getDocs(consultaTenantAtual(query(collection(db, "obras"), ...constraints))),
        getCountFromServer(consultaContagem).catch((err) => {
          console.error("Erro ao contar obras:", err);
          return null;
        }),
      ]);
      setTotalObras(contagem?.data().count ?? null);
      const docsPagina = snapshot.docs.slice(0, itensPerPage);
      const temProximaPagina = snapshot.docs.length > itensPerPage;

      const lista = await Promise.all(
        docsPagina.map(async (d) => {
          const laudos = await buscarLaudosDaObra(d.id);

          return {
            id: d.id,
            ...d.data(),
            laudos,
          };
        })
      );

      setObras(lista);
      setLastDocs((prev) => {
        const updated = [...prev];
        if (docsPagina.length) updated[page] = docsPagina[docsPagina.length - 1];
        return updated;
      });
      setPages(temProximaPagina ? page + 2 : page + 1);
    } catch (err) {
      console.error("Erro ao carregar obras:", err);
    } finally {
      setCarregandoLista(false);
    }
  }

  useEffect(() => {
    if (pesquisa.trim()) return;
    if (usuarioAtual) carregarObras(currentPage);
  }, [currentPage, itensPerPage, filtroStatus, pesquisa, usuarioAtual]);

  useEffect(() => {
    setCurrentPage(0);
    setLastDocs([]);
    setPages(1);
  }, [itensPerPage, filtroStatus]);

  async function carregarObrasParaBusca() {
    setCarregandoLista(true);

    try {
      const constraints = [];
      constraints.push(...tenantWhere(usuarioAtual));

      if (filtroStatus === "ativas") constraints.push(where("ativo", "==", true));
      if (filtroStatus === "inativas") constraints.push(where("ativo", "==", false));

      constraints.push(orderBy("nome", "asc"));

      const snapshot = await getDocs(consultaTenantAtual(query(collection(db, "obras"), ...constraints)));

      const lista = await Promise.all(
        snapshot.docs.map(async (d) => {
          const laudos = await buscarLaudosDaObra(d.id);

          return {
            id: d.id,
            ...d.data(),
            laudos,
          };
        })
      );

      setObrasBusca(lista);
    } catch (err) {
      console.error("Erro ao buscar obras:", err);
      setObrasBusca([]);
    } finally {
      setCarregandoLista(false);
    }
  }

  useEffect(() => {
    setObrasBusca(null);
    setCurrentPage(0);
    setLastDocs([]);
    setPages(1);

    if (pesquisa.trim()) {
      if (usuarioAtual) carregarObrasParaBusca();
    }
  }, [pesquisa, filtroStatus, usuarioAtual]);

  function recarregarListaAposAlteracao(page = currentPage) {
    if (pesquisa.trim()) {
      carregarObrasParaBusca();
      return;
    }

    setObrasBusca(null);
    carregarObras(page);
  }


  async function getUsuarioLogado() {
  return getUsuarioAtualComTenant();
}

  /* =========================
     SALVAR OBRA
  ========================= */
  async function salvarObra() {
  if (!dataCadastro) {
    alert("Informe a data de cadastro.");
    return;
  }
  if (!clienteSelecionado) {
    alert("Selecione um cliente");
    return;
  }

  if (!nome.trim()) {
    alert("Informe o nome da obra");
    return;
  }

  setLoading(true);

  try {
    const usuario = await getUsuarioLogado();

    if (!usuario.tenantId) {
      alert("Usuario sem tenantId. O superadmin deve criar/usar um admin de cliente SaaS para cadastros operacionais.");
      return;
    }

    const dados = aplicarTenant({
      dataCadastro,
      nome: nome.trim(),
      nomeEtiqueta: nomeEtiqueta.trim() || nome.trim(),
      clienteEtiqueta: clienteEtiquetaManual.trim(),
      endereco: endereco.trim(),
      clienteId: clienteSelecionado?.id || null,
      clienteNome: clienteSelecionado?.nome || "",
      prensaRupturaPadrao: resumirPrensa(prensaVinculada),
      rupturaExternaPadrao,
      responsavelProducaoConcreto: responsavelProducaoConcreto.trim(),
      ativo: obraEditando ? obraEditando.ativo : true,
    }, usuario);

    const criandoObra = !obraEditando;

    if (obraEditando) {
      if (podeEditarCadastroDireto(usuario, obraEditando)) {
        const atualizadoEm = Timestamp.now();
        await atualizarDocumentoComMesclagem({
          db,
          referencia: doc(db, "obras", obraEditando.id),
          original: obraEditando,
          atual: { ...obraEditando, ...dados },
          metadados: { atualizadoEm, atualizadoPor: usuario.uid },
        });
      } else if (usuario.tipo === "colaborador") {
        await addDoc(collection(db, "aprovacoes"), aplicarTenantAtual({
          tipo: "obra",
          colecao: "obras",
          registroId: obraEditando.id,
          dadosAtuais: obraEditando,
          dadosSolicitados: extrairCamposAlterados(obraEditando, {
            ...obraEditando,
            ...dados,
          }),
          status: "pendente",
          tenantId: usuario.tenantId,
          criadoEm: Timestamp.now(),
          criadoPor: usuario,
        }));

        alert("Alteração enviada para aprovação do administrador.");
      } else {
        alert("Usuário sem permissão para editar obra.");
        return;
      }
    } else {
      if (usuario.tipo === "admin" || usuario.tipo === "colaborador") {
        await addDoc(collection(db, "obras"), aplicarTenantAtual({
          ...dados,
          criadoEm: Timestamp.now(),
          criadoPor: usuario.uid,
          criadoPorNome: usuario.nome,
          criadoPorTipo: usuario.tipo,
        }));
      } else {
        alert("Usuário sem permissão para cadastrar obra.");
        return;
      }
    }

    setOpenDialog(false);
    setNome("");
    setNomeEtiqueta("");
    setEndereco("");
    setClienteSelecionado(null);
    setClienteEtiquetaManual("");
    setPrensaVinculada(null);
    setRupturaExternaPadrao(false);
    setResponsavelProducaoConcreto("");
    setObraEditando(null);

    if (pesquisa.trim()) {
      recarregarListaAposAlteracao();
    } else {
      setCurrentPage(0);
      setLastDocs([]);
      setPages(1);
      recarregarListaAposAlteracao(0);
    }

    if (
      criandoObra &&
      new URLSearchParams(window.location.search).get("onboarding") === "1"
    ) {
      setOpenCadastroConcluido(true);
    }
  } catch (err) {
    console.error("Erro ao salvar obra:", err);
    alert("Erro ao salvar obra");
  } finally {
    setLoading(false);
  }
}

  /* =========================
     ATIVAR / DESATIVAR
  ========================= */
async function toggleAtivo(obra) {
  try {
    const usuario = await getUsuarioLogado();

    const dados = {
      ativo: !obra.ativo,
    };

    if (podeEditarCadastroDireto(usuario, obra)) {
      await updateDoc(doc(db, "obras", obra.id), dados);
    } else if (usuario.tipo === "colaborador") {
      await addDoc(collection(db, "aprovacoes"), aplicarTenantAtual({
        tipo: "obra",
        tenantId: usuario.tenantId,
        colecao: "obras",
        registroId: obra.id,
        dadosAtuais: obra,
        dadosSolicitados: dados,
        status: "pendente",
        criadoEm: Timestamp.now(),
        criadoPor: usuario,
      }));

      alert("Alteração enviada para aprovação do administrador.");
    } else {
      alert("Usuário sem permissão.");
      return;
    }

    recarregarListaAposAlteracao();
  } catch (err) {
    console.error("Erro ao alterar status:", err);
    alert("Erro ao alterar status da obra.");
  }
}

  /* =========================
     DOWNLOAD PDF
  ========================= */
  async function baixarLaudo(laudo) {
    try {
      const storageRef = ref(storage, laudo.storagePath);
      const url = await getDownloadURL(storageRef);
      window.open(url, "_blank");
    } catch (err) {
      console.error("Erro ao baixar laudo:", err);
    }
  }

  /* =========================
     FILTRO + PESQUISA
  ========================= */
  const obrasFiltradas = useMemo(() => {
  const termoPesquisa = normalizarNome(pesquisa);

  const base = pesquisa.trim() ? (obrasBusca || []) : obras;

  return base
    .filter((obra) => {
      const pesquisaOk =
        !termoPesquisa ||
        [obra.nome, obra.clienteNome].some((campo) =>
          normalizarNome(campo).includes(termoPesquisa)
        );

      const statusOk =
        filtroStatus === "todas" ||
        (filtroStatus === "ativas" && obra.ativo) ||
        (filtroStatus === "inativas" && !obra.ativo);

      return pesquisaOk && statusOk;
    })
    .sort((a, b) =>
      a.nome.localeCompare(b.nome, "pt-BR", {
        sensitivity: "base",
      })
    );
}, [obras, obrasBusca, pesquisa, filtroStatus]);


  /* =========================
     RENDER
  ========================= */
  return (
    <>
      <Navbar open={open} isMobile={isMobile} userName={userName} />

      <Box className="cadastro-obras-container" sx={{ p: 4, mt: 6 }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h5" className="cadastro-obras-title" mb={3}>
          Cadastro de Obras
        </Typography>        

              <Stack
  direction="row"
  spacing={2}
  mb={3}
  alignItems="center"
>
  <Button
    variant="contained"
    onClick={novaObra}
    sx={{
      height: 56,
      whiteSpace: "nowrap",
    }}
  >
    + Cadastrar Obra
  </Button>

  <Button
    variant="outlined"
    startIcon={<HelpOutlineIcon />}
    onClick={() => setOpenTutorial(true)}
    sx={{ height: 56, whiteSpace: "nowrap" }}
  >
    Ver tutorial
  </Button>

  <TextField
    label="Pesquisar obra ou cliente"
    value={pesquisa}
    onChange={(e) => setPesquisa(e.target.value)}
    sx={{ flex: 1 }}   // ocupa o espaço restante
  />

  <Typography variant="body2" sx={{ whiteSpace: "nowrap", fontWeight: 600 }} aria-live="polite">
    Quantidade de obras: {carregandoLista || (pesquisa.trim() && obrasBusca === null)
      ? "..."
      : pesquisa.trim() ? obrasFiltradas.length : totalObras ?? "—"}
  </Typography>

  <TextField
    select
    label="Status"
    value={filtroStatus}
    onChange={(e) => setFiltroStatus(e.target.value)}
    sx={{ width: 180 }}
  >
    <MenuItem value="todas">Todas</MenuItem>
    <MenuItem value="ativas">Ativas</MenuItem>
    <MenuItem value="inativas">Inativas</MenuItem>
  </TextField>
</Stack>
        </Paper>

        <Paper className="cadastro-card">
              <Table className="cadastro-tabela lista-cadastro-padrao">


            <TableHead>
                <TableRow>
                  <TableCell>Cliente / Obra</TableCell>
                  <TableCell>Endereço</TableCell>
                  <TableCell>Último Laudo</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell width={200}>Ações</TableCell>
                </TableRow>
              </TableHead>
           
            <TableBody>
              {carregandoLista && (
                <TableRow>
                  <TableCell colSpan={5}>Carregando...</TableCell>
                </TableRow>
              )}

              {!carregandoLista && obrasFiltradas.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5}>
                    Nenhuma obra encontrada.
                  </TableCell>
                </TableRow>
              )}

              {obrasFiltradas.map((obra) => {
                const ultimoLaudo = obra.laudos[0];

                return (
                 <TableRow key={obra.id}>
                    <TableCell>
                      <div className="lista-dado-principal">{obra.clienteNome || "-"}</div>
                      <div className="lista-dado-secundario">Obra: {obra.nome || "-"}</div>
                    </TableCell>
                    <TableCell className="lista-dado-secundario">{obra.endereco || "-"}</TableCell>

                    <TableCell align="left">
                      {ultimoLaudo ? (
                        <Link
                          className="link-pdf"
                          component="button"
                          onClick={() => baixarLaudo(ultimoLaudo)}
                        >
                          📄 {ultimoLaudo.nomeArquivo}
                        </Link>
                      ) : (
                        <span className="texto-secundario">
                          Nenhum laudo
                        </span>
                      )}
                    </TableCell>

                    <TableCell
                      className={
                        obra.ativo ? "status-ativa" : "status-inativa"
                      }
                    >
                      {obra.ativo ? "Ativa" : "Inativa"}
                    </TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => editarObra(obra)}
                        >
                          Editar
                        </Button>                        

                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => toggleAtivo(obra)}
                        >
                          {obra.ativo ? "Desativar" : "Ativar"}
                        </Button>
                        <HistoricoCadastro colecao="obras" documentoId={obra.id} registro={obra} />
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>

        {!pesquisa.trim() && (
          <Stack direction="row" justifyContent="space-between" mt={2}>
            <PaginationSelector itensPerPage={itensPerPage} setItensPerPage={setItensPerPage} />
            <PaginationComponent pages={pages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </Stack>
        )}
        <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                fullWidth
                maxWidth="sm"
              >

                
                <DialogTitle>
                  {obraEditando ? "Editar Obra" : "Nova Obra"}
                </DialogTitle>

                <DialogContent dividers>

                  <Autocomplete
                        options={clientes}
                        getOptionLabel={(option) => option.nome}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        value={clienteSelecionado}
                        onChange={(event, newValue) => {
                          setClienteSelecionado(newValue);
                          setPrensaVinculada((prensaAtual) =>
                            prensaAtual &&
                            normalizarNome(
                              prensaAtual.empresa || prensaAtual.cliente
                            ) === normalizarNome(newValue?.nome)
                              ? prensaAtual
                              : null
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Cliente"
                            placeholder="Pesquisar cliente..."
                            fullWidth 
                          />
                        )}
                      />
                  <Stack spacing={2} mt={1}>
                    <TextField label="Data de cadastro" type="date" value={dataCadastro} onChange={(e) => setDataCadastro(e.target.value)} InputLabelProps={{ shrink: true }} required fullWidth />
                    <TextField
                      label="Nome da Obra"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      fullWidth
                    />
                    <TextField
                    label="Endereço da Obra"
                    value={endereco}
                    onChange={(e) => setEndereco(e.target.value)}
                    fullWidth
                  />
                    <TextField
                      label="Cliente (Etiqueta)"
                      value={clienteEtiquetaManual}
                      onChange={(e) => setClienteEtiquetaManual(e.target.value)}
                      fullWidth
                    />
                    <TextField
                      label="Nome da Obra (Etiqueta)"
                      value={nomeEtiqueta}
                      onChange={(e) => setNomeEtiqueta(e.target.value)}
                      fullWidth
                    />
                    <Autocomplete
                      freeSolo
                      options={concreteiras.map((concreteira) => concreteira.nome)}
                      value={responsavelProducaoConcreto}
                      onChange={(_, valor) => setResponsavelProducaoConcreto(valor || "")}
                      onInputChange={(_, valor) => setResponsavelProducaoConcreto(valor)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Responsável pela produção do concreto"
                          placeholder="Selecione uma concreteira ou digite manualmente"
                          helperText="Será preenchido automaticamente ao criar uma nova moldagem desta obra."
                          fullWidth
                        />
                      )}
                    />
                    <Autocomplete
                      options={calibracoesDisponiveis}
                      value={prensaVinculada}
                      onChange={(_, novaPrensa) => setPrensaVinculada(novaPrensa)}
                      getOptionLabel={formatarOpcaoPrensa}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Prensa vinculada"
                          placeholder="Selecione pelo número do certificado"
                          helperText="Será preenchida automaticamente ao lançar uma carga de ruptura."
                          fullWidth
                        />
                      )}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={mostrarTodosCertificados}
                          onChange={(event) =>
                            setMostrarTodosCertificados(event.target.checked)
                          }
                        />
                      }
                      label="Mostrar todos os certificados de calibração"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={rupturaExternaPadrao}
                          onChange={(event) =>
                            setRupturaExternaPadrao(event.target.checked)
                          }
                        />
                      }
                      label="Ruptura externa por padrão na Agenda de Ruptura"
                    />

                    
                  </Stack>
                </DialogContent>

                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>
                    Cancelar
                  </Button>

                  <Button
                    variant="contained"
                    onClick={salvarObra}
                    disabled={loading}
                  >
                    {loading
                      ? <CircularProgress size={22} />
                      : obraEditando ? "Atualizar" : "Salvar"}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog open={openCadastroConcluido} maxWidth="sm" fullWidth>
                <DialogTitle>Cadastro inicial concluído!</DialogTitle>
                <DialogContent dividers>
                  <Box component="p" sx={{ mt: 0 }}>
                    Cliente e obra cadastrados. Agora você já pode utilizar todo o sistema.
                  </Box>
                  <Box component="p" sx={{ mb: 0 }}>
                    Caso tenha outros clientes ou obras, cadastre todos eles para que cada ensaio fique corretamente vinculado e mantenha sua rastreabilidade.
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button variant="contained" onClick={() => history.push("/dashboard")}>
                    Ir para o início
                  </Button>
                </DialogActions>
              </Dialog>
              <TutorialCadastro
                open={openTutorial}
                onClose={() => setOpenTutorial(false)}
                titulo="Tutorial — Cadastro de Obras"
                etapas={ETAPAS_TUTORIAL_OBRAS}
              />
      </Box>
    </>
  );
}
